var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.536,
    height: 12,
    viewBox: "0 0 9.536 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1d0e3d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.789,0H1.8A1.754,1.754,0,0,0,0,1.8v9.589a.621.621,0,0,0,.077.316.73.73,0,0,0,.218.232.427.427,0,0,0,.3.056.745.745,0,0,0,.3-.127L4.738,9.111l3.838,2.756a.9.9,0,0,0,.176.091.489.489,0,0,0,.176.035,1.317,1.317,0,0,0,.155-.007.623.623,0,0,0,.155-.049.9.9,0,0,0,.211-.232.58.58,0,0,0,.084-.316V1.8A1.623,1.623,0,0,0,9.069.513,1.722,1.722,0,0,0,7.789,0Zm.6,10.25L5.16,7.916q-.1-.042-.19-.084a.387.387,0,0,0-.351,0q-.091.042-.19.084L1.2,10.25V1.8a.6.6,0,0,1,.162-.443A.6.6,0,0,1,1.8,1.2H7.789a.6.6,0,0,1,.443.162.6.6,0,0,1,.162.443Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.f1014c5db2b939dc1796eb975cf74e6b.svg";
export { ForwardRef as ReactComponent };